import { render, staticRenderFns } from "./DataElement.vue?vue&type=template&id=74b9826a&"
import script from "./DataElement.vue?vue&type=script&lang=js&"
export * from "./DataElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports